<ion-content [fullscreen]="true">
  <h1>FUCK YOU</h1>
</ion-content>